<template>
  <div id="app">
    <TabBar v-if="isShow"/>
    <router-view/>
  </div>
</template>

<script>
import TabBar from './components/TabBar.vue'
import {getUrlKey} from "@/utils/jiutang";
import store from "@/store";

export default {
  name: 'app',
  components: {
    TabBar
  },
  data() {
    return {
      isShow: false
    }
  },
  created() {
    // window.onload = function () {
    //
    //   document.addEventListener('touchstart', function (event) {
    //
    //     if (event.touches.length > 1) {
    //
    //       event.preventDefault()
    //
    //     }
    //
    //   })
    //
    //   document.addEventListener('gesturestart', function (event) {
    //
    //     event.preventDefault()
    //
    //   })
    //
    // }
    //
    // document.documentElement.addEventListener('touchstart', function (event) {
    //   if (event.touches.length > 1) {
    //     event.preventDefault();
    //   }
    // }, false);
    //
    // var lastTouchEnd = 0;
    // document.documentElement.addEventListener('touchend', function (event) {
    //   var now = Date.now();
    //   if (now - lastTouchEnd <= 300) {
    //     event.preventDefault();
    //   }
    //   lastTouchEnd = now;
    // }, false);

    let token = getUrlKey("token")
    console.log(token)
    if (token) {
      store.dispatch("Login", token).then(() => {
        let url = window.location.href;
        if (url) {
          if (url.indexOf('?token') != -1) {
            url = url.substring(0, url.indexOf('?token'))
            window.location.href = url
          }
        }
      })
    }
  },
  mounted() {

  },
  watch: {
    '$route': {
      handler(to, from) {
        if (to.path === '/' || to.path === '/activity' || to.path === '/news' || to.path === '/mine') {
          this.isShow = true;
        } else {
          this.isShow = false;
        }
      },
      deep: true,
      immediate: true,
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333333;
}
</style>
